module.exports = __webpack_public_path__ + "static/media/feIcon.a54adaed.svg";